import { useSmartQuery } from "@shared/api/queries/hooks";
import { QueryKeyFactory } from "@shared/api/queries/queryKeyFactory";
import { getBillCycleList, getDashboardData, getSummaryData } from "./api";

export const useSummaryData = (id: any) => {
  return useSmartQuery(
    [QueryKeyFactory.module.bx.dashboard.summaryData(), id],
    () => getSummaryData(id),
    {
      staleTime: 5 * 60 * 1000,
      refetchOnWindowFocus: false,
      enabled: !!id,
    }
  );
};

export const useDashboardData = (date: any) => {
  return useSmartQuery(
    [QueryKeyFactory.module.bx.dashboard.dashboard(), date],
    () => getDashboardData(date),
    {
      staleTime: 5 * 60 * 1000,
      refetchOnWindowFocus: false,
      enabled: !!date,
    }
  );
};

export const useBillCycleList = () => {
  return useSmartQuery(
    QueryKeyFactory.module.bx.dashboard.billCycleList(),
    () => getBillCycleList(),
    {
      staleTime: 5 * 60 * 1000, // 5 minutes
      refetchOnWindowFocus: false,
    }
  );
};
